<template>
  <hm-content title="">
    <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
    >
      <el-form-item label="任务名称：" prop="taskName">
        <el-input
            type="text"
            v-model.trim="ruleForm.taskName"
            clearable
            placeholder="请输入任务名称"
            size="small"
        ></el-input>
      </el-form-item>
      <el-form-item
          label="分配规则："
          prop="distributeRule"
      >
        <el-radio-group
            v-model="ruleForm.distributeRule"
        >
          <el-radio label="byAvg">
            平均随机分配
          </el-radio>
          <el-radio label="byGuider">
            按导购分配
          </el-radio>
        </el-radio-group>
        <div class="form-item-tip" v-if="ruleForm.distributeRule === 'byGuider'">
          请在分配会员的模板中填写导购的信息,否则导购分配将会失败
        </div>
      </el-form-item>
      <el-form-item label="选择机构：" prop="orgCode" v-if="ruleForm.distributeRule === 'byAvg'">
        <el-cascader
            ref="cascader"
            clearable
            v-model="ruleForm.orgCode"
            :props="props"
            placeholder="请选择机构"
            :show-all-levels="false"
            size="small"
            class="mr10"
            @change="changeOrgCode"
        ></el-cascader>
      </el-form-item>
      <el-form-item
          label="导购筛选："
          v-show="ruleForm.orgCode.length"
          prop="employeeIdList"
          v-if="ruleForm.distributeRule === 'byAvg'"
      >
        <div class="daogou-bder">
          <el-transfer
              class="daogou-transfer"
              v-model="ruleForm.employeeIdList"
              filterable
              filter-placeholder="请输入导购名称"
              :titles="['所有导购', '给下列导购安排任务']"
              :button-texts="['到左边', '到右边']"
              @change="handleChange"
              :data="data"
          >
          </el-transfer>
        </div>
      </el-form-item>
      <el-form-item label="会员基础筛选：" prop="model">
        <el-radio-group v-model="ruleForm.model" size="small">
          <el-radio-button label="auto" v-if="ruleForm.distributeRule === 'byAvg'">自动筛选</el-radio-button>
          <el-radio-button label="manual">手动筛选</el-radio-button>
          <el-radio-button label="peoplePackage">选择推荐人群</el-radio-button>
          <el-radio-button label="tagGroup">选择自建人群</el-radio-button>
        </el-radio-group>
        <div v-if="ruleForm.model === 'auto'">
          <!-- <div>
            <el-radio-group v-model="ruleForm.ruleType">
              <el-radio label="no">有宝宝</el-radio>
              <el-radio label="yes">孕期</el-radio>
            </el-radio-group>
          </div>
          <div>
            <div class="flex flex-wrap">
              <div style="width:70px;">
                宝宝性别
              </div>

              <el-select
                size="small"
                v-model="ruleForm.baby"
                filterable
                class="ml10"
                clearable
                placeholder="请选择宝宝性别"
              >
                <el-option label="男" value="boy"></el-option>
                <el-option label="女" value="girl"></el-option>
              </el-select>
            </div>
            <div class="flex flex-wrap">
              <div style="width:70px;">
                宝宝年龄段
              </div>
              <el-select
                size="small"
                v-model="ruleForm.babyAge"
                filterable
                class="ml10"
                clearable
                placeholder="请选择宝宝年龄段"
              >
                <el-option label="1-10" value="1-10"></el-option>
                <el-option label="11-12" value="11-12"></el-option>
              </el-select>
            </div>
            <div class="flex flex-wrap">
              <div style="width:70px;">
                消费能力
              </div>

              <el-select
                size="small"
                v-model="ruleForm.baby"
                filterable
                class="ml10"
                clearable
                placeholder="请选择消费能力"
              >
                <el-option label="男" value="boy"></el-option>
                <el-option label="女" value="girl"></el-option>
              </el-select>
            </div>
            <div class="flex flex-wrap">
              <div style="width:70px;">
                客户活跃度
              </div>
              <el-select
                size="small"
                v-model="ruleForm.baby"
                filterable
                class="ml10"
                clearable
                placeholder="请选择客户活跃度"
              >
                <el-option label="男" value="boy"></el-option>
                <el-option label="女" value="girl"></el-option>
              </el-select>
            </div>
          </div> -->
        </div>
        <div v-else-if="ruleForm.model === 'manual'" >
          <div>
            <div class="form-tip">
              注:导入格式需按照用户名、电话、名单来源顺序导入，导入同名文件请刷新后再导入，数据量过大时将会造成页面卡顿!
            </div>
            <div class="flex flex-between">
              <div>
                选择分配的会员
              </div>
              <div>
                <el-button
                    type="primary"
                    @click="output('模板')"
                    :loading="isOutputing"
                    size="small"
                >下载<span v-if="ruleForm.distributeRule === 'byGuider' ">导购分配</span>模板</el-button
                >
                <span class="open-file pointer ml10">
                  <input
                      class="pointer"
                      type="file"
                      @change="importf"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  />
                  <el-button class="pointer" type="primary" size="small"
                  >导入数据</el-button
                  >
                </span>
              </div>
            </div>
            <div class="table">
              <el-table
                  stripe
                  border
                  ref="table"
                  :data="guiderTemplateList"
                  style="width: 100%"
                  size="small"
                  max-height="400"
                  v-if="ruleForm.distributeRule === 'byGuider'"
              >
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="memberName"
                    label="会员姓名"
                >
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="memberPhone"
                    label="会员手机号"
                >
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="source"
                    label="名单来源"
                >
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="guiderPhone"
                    label="分配导购手机号"
                >
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="guiderName"
                    label="分配导购姓名"
                >
                </el-table-column>
              </el-table>
              <el-table
                  stripe
                  border
                  ref="table"
                  :data="memberTemplateList"
                  style="width: 100%"
                  size="small"
                  max-height="400"
                  v-else
              >
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="name"
                    label="用户名"
                >
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="mobile"
                    label="手机号"
                >
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="source"
                    label="名单来源"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div v-else-if="ruleForm.model === 'tagGroup'" >
          <div>
            <div class="flex flex-between">
              <div>请在分配会员的模板中填写导购的信息，否则导购分配将会失败</div>
              <span class="open-file pointer ml10" v-if="ruleForm.distributeRule === 'byGuider'" >
                <input
                    class="pointer"
                    type="file"
                    @change="importf"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
                <el-button class="pointer" type="primary" size="small"
                >导入数据</el-button
                >
                <span class="green" v-if="guiderTemplateList && guiderTemplateList.length">(导入成功)</span>
              </span>
            </div>
            <div class="table mt20">
              <el-table
                  stripe
                  border
                  ref="table"
                  :data="groupList"
                  style="width: 100%"
                  size="small"
                  max-height="400"
                  highlight-current-row
                  @current-change="getCurrentRow"
              >
                <!-- <el-table-column label="选择客户分群" align="center" width="100">
                  <template slot-scope="scope">
                    <el-radio :label="scope.$index + 1" v-model="radio"
                              @change.native="getCurrentRow(scope.row)"></el-radio>
                  </template>
                </el-table-column> -->
                <el-table-column
                    header-align="center"
                    align="center"
                    type="index"
                    label="序号"
                    width="50"
                    :index="
                    (index) => index + (currentPage - 1) * pageSize + 1
                  "
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="groupName"
                    label="人群名称"
                >
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="estimateNum"
                    label="人群人数"
                >
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    label="操作"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <el-button size="small" type="text" @click="downloadGroupInfo(scope.row)">下载会员明细</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="hm-pagination">
                <el-pagination
                    background
                    :total="total"
                    @current-change="paging"
                    @size-change="handleSizeChange"
                    layout="total,sizes,  prev, pager, next, jumper"
                    :current-page="currentPage"
                ></el-pagination>
              </div>
            </div>
            <div class="table mt20">
              <el-table
                  stripe
                  border
                  ref="table"
                  :data="guiderTemplateList"
                  style="width: 100%"
                  size="small"
                  max-height="400"
                  v-if="ruleForm.distributeRule === 'byGuider' && guiderTemplateList.length"
              >
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="memberName"
                    label="会员姓名"
                >
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="memberPhone"
                    label="会员手机号"
                >
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="source"
                    label="名单来源"
                >
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="guiderPhone"
                    label="分配导购手机号"
                >
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="guiderName"
                    label="分配导购姓名"
                >
                </el-table-column>
              </el-table>
            </div>

          </div>
        </div>
        <div v-else-if="ruleForm.model === 'peoplePackage'">
          <div class="flex flex-between">
            <div>
              <span v-if="ruleForm.distributeRule === 'byAvg'">请选择其中一条会员人群记录</span>
              <span v-else-if="ruleForm.distributeRule === 'byGuider'">请先下载会员明细,再导入数据</span>
            </div>
            <span class="open-file pointer ml10" v-if="ruleForm.distributeRule === 'byGuider'">
              <input
                  class="pointer"
                  type="file"
                  @change="importf"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
              <el-button class="pointer" type="primary" size="small"
              >导入数据</el-button
              >
              <span class="green" v-if="guiderTemplateList && guiderTemplateList.length">(导入成功)</span>
            </span>
          </div>
          <div class="table mt20">
            <el-table
                stripe
                :data="reportsList"
                style="width: 100%"
                id="table"
                size="small"
                border
                :max-height="400"
                highlight-current-row
                @current-change="handleCurrentChange"
            >
              <el-table-column
                  header-align="center"
                  align="center"
                  type="index"
                  label="序号"
                  width="50"
                  :index="
                  (index) => index + (currentPageReports - 1) * pageSizeReports + 1
                "
              ></el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="reportResultName"
                  label="自定义名称"
              >
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="reportName"
                  label="人群包名称"
              >
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="resultRowsNum"
                  label="人群人数"
              >
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="schedulingTime"
                  label="执行时间"
              >
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="realname"
                  label="操作人"
              >
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  label="操作"
                  width="200"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button size="small" type="text" @click="save(scope.row)"
                    >下载会员明细</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <el-table
                stripe
                border
                ref="table"
                :data="guiderTemplateList"
                style="width: 100%"
                size="small"
                max-height="400"
                class="mt20"
                v-if="ruleForm.distributeRule === 'byGuider' && guiderTemplateList.length"
            >
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberName"
                  label="会员姓名"
              >
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberPhone"
                  label="会员手机号"
              >
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="source"
                  label="名单来源"
              >
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="guiderPhone"
                  label="分配导购手机号"
              >
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="guiderName"
                  label="分配导购姓名"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-form-item>
      <el-form-item
          label="任务时长："
          prop="cycleDays"
          v-if="ruleForm.model === 'auto'"
      >
        <el-input
            type="text"
            @input="filterGt0OrFixed0('cycleDays')"
            v-model.trim="ruleForm.cycleDays"
            clearable
            placeholder="请输入任务时长"
            size="small"
        ></el-input
        >天
        <!-- <el-date-picker
          v-model="ruleForm.activityDate"
          type="daterange"
          align="right"
          start-placeholder="任务开始时间"
          end-placeholder="任务结束时间"
          value-format="yyyy-MM-dd"
          size="small"
          class="mr10"
        ></el-date-picker> -->
      </el-form-item>
      <el-form-item
          label="转化成功统计："
          prop="transType"
      >
        <el-radio-group
            v-model="ruleForm.transType"
        >
          <el-radio label="phone">
            不统计转化
          </el-radio>
          <el-radio label="order">
            用户支付订单
          </el-radio>
        </el-radio-group>
        <div class="form-tip" v-if="ruleForm.transType === 'order'">
          导购联系<el-input
            size="small"
            clearable
            style="width: 80px"
            class="ml10 mr10 ipt"
            @input="filterGt0('delayDays')"
            maxlength="2"
            v-model.trim="ruleForm.delayDays"
        ></el-input
        >天内，用户产生线上或线下交易即为转化成功
        </div>
      </el-form-item>
      <el-form-item
          label="任务时段："
          prop="activityDate"
          v-if="ruleForm.model === 'manual' || ruleForm.model === 'peoplePackage' || ruleForm.model === 'tagGroup' "
      >
        <el-date-picker
            v-model="ruleForm.activityDate"
            type="daterange"
            align="right"
            start-placeholder="任务开始时间"
            end-placeholder="任务结束时间"
            value-format="yyyy-MM-dd"
            size="small"
            class="mr10"
        ></el-date-picker>
      </el-form-item>
      <el-form-item
          label="任务产生基于："
          prop="model"
          v-if="ruleForm.model === 'auto'"
      >
        <el-radio-group v-model="ruleForm.ruleType">
          <!-- <el-radio label="new_member">新客转化</el-radio>
          <el-radio label="loss_warning">流失预警</el-radio>
          <el-radio label="repurchase_recommendation">复购推荐</el-radio> -->
          <el-radio label="stage_sale">用户生理轴</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
          label="生理轴设置："
          prop="preDays"
          v-if="ruleForm.model === 'auto'"
      >
        <!-- <el-checkbox-group v-model="ruleForm.slz" size="small" class="ml10">
          <el-checkbox label="pushMember">孕妇</el-checkbox>
          <el-checkbox label="plusMembers">婴儿</el-checkbox>
        </el-checkbox-group> -->
        <div>
          当前生理轴到期前
          <el-input
              type="text"
              @input="filterGt0OrFixed0('preDays')"
              v-model.trim="ruleForm.preDays"
              clearable
              size="small"
          ></el-input
          >天，发布任务
        </div>
      </el-form-item>
      <el-form-item
          label="会员类型"
          prop="memberSelectType"
          v-if="ruleForm.model === 'auto'"
      >
        <el-select
            size="small"
            placeholder="选择优惠券包"
            v-model="ruleForm.memberSelectType"
            filterable
            class="mr10"
        >
          <!-- <el-option label="全部类型推荐人" value="all"></el-option> -->
          <el-option label="会员卡类型" value="member_card"></el-option>
          <!-- <el-option label="会员群组" value="group"></el-option> -->
        </el-select>
        <el-select
            clearable
            v-if="ruleForm.memberSelectType === 'member_card'"
            class="mr10"
            size="small"
            v-model="ruleForm.typeRelIdList"
            placeholder="请选择卡类型"
            filterable
            multiple
        >
          <el-option
              :label="v.typeName"
              :value="v.cardTypeId"
              :key="i"
              v-for="(v, i) in cardTypeList"
          ></el-option>
        </el-select>
        <el-select
            v-if="ruleForm.memberSelectType === 'group'"
            clearable
            multiple
            filterable
            size="small"
            v-model="ruleForm.groupIds"
            placeholder="请选择会员群组"
        >
          <el-option
              :label="v.groupAppellation"
              :value="v.groupId"
              v-for="(v, i) in memberGroupList"
              :key="i"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="会员消费筛选：" prop="member">
        <div class="flex flex-wrap">
          <div style="width:100px;">
            品类列表筛选
          </div>

          <el-select
            size="small"
            v-model="ruleForm.baby"
            filterable
            class="ml10"
            clearable
            placeholder="请选择品类列表筛选"
          >
            <el-option label="男" value="boy"></el-option>
            <el-option label="女" value="girl"></el-option>
          </el-select>
        </div>
        <div class="flex flex-wrap">
          <div style="width:100px;">
            品牌列表筛选
          </div>
          <el-select
            size="small"
            v-model="ruleForm.babyAge"
            filterable
            class="ml10"
            clearable
            placeholder="请选择品牌"
          >
            <el-option label="1-10" value="1-10"></el-option>
            <el-option label="11-12" value="11-12"></el-option>
          </el-select>
        </div>
        <div class="flex flex-wrap">
          <div style="width:100px;">
            商品货号筛选
          </div>
          <el-input
            type="text"
            v-model.trim="ruleForm.promotionName"
            clearable
            class="ml10"
            placeholder="请输入商品货号"
            size="small"
          ></el-input>
        </div>
        <div class="flex flex-wrap">
          <div style="width:100px;">
            购买时间筛选
          </div>
          <div class="flex item-center">
            <el-date-picker
              :default-time="['00:00:00', '23:59:59']"
              v-model="ruleForm.buyDate"
              type="datetimerange"
              align="right"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="ml10"
            ></el-date-picker>
          </div>
        </div>
      </el-form-item> -->
    </el-form>
    <div class="flex flex-center">
      <el-button type="primary" size="small" @click="submitForm('ruleForm')"
      >发布</el-button
      >
      <el-button size="small" @click="$router.back(-1)">返回</el-button>
    </div>
  </hm-content>
</template>

<script>
import XLSX from "xlsx";
import axios from "axios";

let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {},
  data() {
    const validatorFunc = (rule, val, callback) => {
      if (val === "manual") {
        if(this.ruleForm.distributeRule === 'byGuider')
        {
          if (this.guiderTemplateList.length < 1) {
            return callback(new Error("请导入模板"));
          }
        }else{
          if (this.memberTemplateList.length < 1) {
            return callback(new Error("请导入模板"));
          }
        }
      }

      callback();
    };
    const validatorMemberSelectFunc = (rule, val, callback) => {
      if (val === "member_card") {
        if (this.ruleForm.typeRelIdList.length === 0) {
          return callback(new Error("请选择会员卡类型类型"));
        }
      }
      // if (this.ruleForm.slz.length === 0) {
      //   return callback(new Error("请选择生理轴类型"));
      // }
      callback();
    };
    return {
      memberTemplateList: [],
      guiderTemplateList: [],
      data: [],
      templateSelection: {},
      radio: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      isOutputing: false,
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
                .dispatch("queryOrganizationTree", {
                  pageNo: 1,
                  pageSize: 999,
                  loginType: "store"
                })
                .then(res => {
                  res.result.records.forEach(v => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.orgCode;
                    v.label = v.departName;
                  });
                  resolve(res.result.records);
                });
          } else {
            this.$store
                .dispatch("queryOrganizationListByParent", {
                  parentId: data.treeStruct,
                  loginType: "store"
                })
                .then(res => {
                  if (res.code === "0" && res.result) {
                    res.result.forEach(v => {
                      v.leaf = Boolean(!v.isParent);
                      v.value = v.orgCode;
                      v.label = v.departName;
                    });
                    resolve(res.result);
                  } else {
                    resolve([]);
                  }
                });
          }
        }
      },
      ruleForm: {
        taskName: "",
        cycleDays: "",
        orgCode: "",
        activityDate: [],
        employeeIdList: [],
        model: "manual",
        ruleType: "stage_sale",
        preDays: "",
        memberSelectType: "member_card",
        typeRelIdList: [],
        distributeRule: "byAvg",
        transType: "phone",
        delayDays: "",
      },
      groupList: [],
      tagGroupId: '',
      rules: {
        taskName: {
          required: true,
          message: "请输入任务名称",
          trigger: "change"
        },
        activityDate: [
          {
            required: true,
            message: "请选择任务时间",
            trigger: "change"
          }
        ],
        cycleDays: [
          {
            required: true,
            message: "请输入任务时长",
            trigger: "change"
          },
          {
            required: true,
            pattern: /^[1-9][0-9]*$/,
            message: "请输入正整数",
            trigger: "blur"
          }
        ],
        orgCode: {
          required: true,
          message: "请选择机构",
          trigger: "change"
        },
        employeeIdList: {
          required: true,
          message: "请选择任务导购",
          trigger: "change"
        },
        model: [
          {
            required: true,
            message: "请选择会员基础",
            trigger: "change"
          },
          {
            required: true,
            validator: validatorFunc,
            trigger: "blur"
          }
        ],
        preDays: [
          {
            required: true,
            pattern: /^[1-9][0-9]*$/,
            message: "请输入正整数",
            trigger: "blur"
          }
        ],
        memberSelectType: [
          {
            required: true,
            message: "请选择会员基础",
            trigger: "change"
          },
          {
            required: true,
            validator: validatorMemberSelectFunc,
            trigger: "blur"
          }
        ]
      },
      memberGroupList: [],
      cardTypeList: [],
      rows:{},
      reportsList: [],
      currentPageReports: 1,
      pageSizeReports: 10,
    };
  },
  computed: {},
  watch: {},
  created() {
    if(this.$route.query.model){
      this.ruleForm.model = this.$route.query.model;
    }
    if (this.$route.query.groupId) {
      this.ruleForm.model = 'tagGroup';
      this.queryGroupInfo();
    } else {
      this.queryGroupList();
    }
  },
  mounted() {
    this.queryMemberGroupList();
    this.queryCardTypeList();
    this.queryReportsList();
  },
  methods: {
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    async queryMemberGroupList() {
      const { result } = await this.$store.dispatch("queryMemberGroupList", {
        pageNo: 1,
        pageSize: 9999
      });

      const { records } = result;
      this.memberGroupList = records;
    },
    async queryCardTypeList() {
      const { result } = await this.$store.dispatch("queryCardTypeList", {
        pageNo: 1,
        pageSize: 99999
      });
      this.cardTypeList = result;
    },
    handleChange(value, direction, movedKeys) {},
    changeOrgCode(val) {
      this.ruleForm.employeeIdList = [];
      if (val.length) {
        this.$store
            .dispatch("queryEmployee", {
              pageNo: 1,
              pageSize: 9999,
              loginType: "store",
              workingState: "yes",
              orgCode: val[val.length - 1]
            })
            .then(res => {
              let list = [];
              res.result.records.forEach((v, i) => {
                list.push({
                  label: v.realname,
                  key: v.employeeId,
                  pinyin: v.realname
                });
              });
              this.data = list;
            });
      } else {
        this.data = [];
      }
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        if(this.ruleForm.transType === 'order' && !this.ruleForm.delayDays){
          this.$message({
            message: "请输入导购联系天数！",
            type: "warning"
          });
          return;
        }
        if(this.ruleForm.distributeRule === 'byAvg' && this.ruleForm.model === 'peoplePackage' && this.rows && !this.rows.recordId){
          this.$message({
            message: "请选择人群包！",
            type: "warning"
          });
          return;
        }
        if(this.ruleForm.distributeRule === 'byGuider' && this.ruleForm.model === 'peoplePackage' && this.guiderTemplateList && !this.guiderTemplateList.length){
          this.$message({
            message: "请上传导入人群包数据！",
            type: "warning"
          });
          return;
        }
        if (this.ruleForm.distributeRule === 'byAvg' && this.ruleForm.model === 'tagGroup' && !this.tagGroupId) {
          this.$message({
            message: "请选择客户分群！",
            type: "warning"
          });
          return;
        }
        const params = JSON.parse(JSON.stringify(this.ruleForm));
        if(this.ruleForm.distributeRule === 'byGuider'){
          params.guiderTemplateList = this.guiderTemplateList;
          params.memberTemplateList = [];
          let checkGuiderPhone = true;
          this.guiderTemplateList.forEach(v=>{
            if(!v.guiderPhone){
              checkGuiderPhone = false;
            }
          })
          // if(!checkGuiderPhone){
          //   this.$message({
          //     message: "请检查导入数据分配导购手机号是否填写完整！",
          //     type: "warning"
          //   });
          //   return;
          // }
        }else{
          params.memberTemplateList = this.memberTemplateList;
          params.guiderTemplateList = [];
          params.responseResultPath = this.rows.responseResultPath;
        }
        if (params.model === "manual" || params.model === "peoplePackage") {
          params.startDate = params.activityDate[0];
          params.endDate = params.activityDate[1];
          params.memberSelectType = "";
          params.ruleType = "";
        }
        if (this.ruleForm.distributeRule === 'byAvg' && this.ruleForm.model === 'tagGroup') {
          params.guiderTemplateList = this.guiderTemplateList;
          params.memberTemplateList = [];
          let checkGuiderPhone = true;
          this.guiderTemplateList.forEach(v=>{
            if(!v.guiderPhone){
              checkGuiderPhone = false;
            }
          })
          params.tagGroupId = this.tagGroupId;
          params.startDate = params.activityDate[0];
          params.endDate = params.activityDate[1];
        }
        if (this.ruleForm.distributeRule === 'byGuider' && this.ruleForm.model === 'tagGroup') {
          params.startDate = params.activityDate[0];
          params.endDate = params.activityDate[1];
        }
        params.orgCode = params.orgCode[params.orgCode.length - 1];
        this.$store.dispatch("addGuiderTask", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.$router.back(-1);
          }
        });
      } else {
        return false;
      }
    },
    importf(e) {
      const obj = e.target;
      this.inputData = [];
      if (!obj.files) {
        return;
      }

      let f = obj.files[0];
      this.fileName = f.name;
      let reader = new FileReader();
      reader.onload = e => {
        let data = e.target.result;

        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          if(this.ruleForm.distributeRule === 'byGuider' && this.ruleForm.model === 'peoplePackage'){
            wb = XLSX.read(data, { type: 'binary', codepage: 936 })
          }else{
            wb = XLSX.read(data, {
              type: "binary"
            });
          }
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName]);
          if (roa.length) {
            result = roa;
          }
        });
        let arr = [];
        console.log("上传:",result);

        result.map(v => {
          let obj = {};
          if(this.ruleForm.distributeRule === 'byGuider'){
            obj.source = v.名单来源;
            obj.memberPhone = v.会员手机号;
            obj.memberName = v.会员姓名;
            obj.guiderPhone = v.分配导购手机号;
            obj.guiderName = v.分配导购姓名;
          }else{
            obj.source = v.名单来源;
            obj.mobile = v.手机号;
            obj.name = v.用户名;
          }
          arr.push(obj);

          // formatResult.push({});
          // this.memberTemplateList.map((o, index) => {
          //   formatResult[i][this.memberTemplateList[index]] = v[index];
          // });
        });
        if(this.ruleForm.distributeRule === 'byGuider'){
          this.guiderTemplateList = [...arr];
        }else{
          this.memberTemplateList = [...arr];
        }
        // formatResult = arrayUnique2(formatResult, this.filterText);
        // this.$emit("importSuccess", formatResult);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    // 导出excel
    output(title) {
      if(this.ruleForm.distributeRule === 'byGuider'){
        title = "按导购分配模板"
      }
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        let list = [];
        const tHeader = this.$refs.table.columns
            .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
            .filter(o => o);
        let filterVal = [];
        if (list.length > 0) {
          filterVal = this.$refs.table.$children
              .map(o => o._props.prop)
              .filter(o => o);
        }
        const data = this.formatJson(filterVal, list);
        exportJsonToExcel(tHeader, data, title + new Date().toLocaleString());
        this.isOutputing = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 过滤大于0
    filterGt0(prop) {
      if (this.ruleForm[prop].length === 1) {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/[^0-9]/g, "");
      } else {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|\D/g, "");
      }
    },
    async queryReportsList() {
      let params = {
        showZeroRecord: "no",
      };
      const { result } = await this.$store.dispatch(
          "queryPeoplePackageDetailResult",
          params
      );
      this.reportsList = result;
    },
    paging(page) {
      this.currentPage = page;
      this.queryGroupList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryGroupList();
    },
    async queryGroupInfo() {
      const { result } = await this.$store.dispatch(
          "tagGroupDetail",
          {groupId: this.$route.query.groupId}
      );
      this.groupList.push(result);
    },
    async queryGroupList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage

      };
      const { result } = await this.$store.dispatch(
          "tagGroupList",
          params
      );
      this.groupList = result.records;
      console.log(this.groupList)
      this.total = result.total;
    },
    downloadGroupInfo(row) {
      let params = {
        exportName: "客户分群人员导出",
        groupId: row.groupId
      }
      this.$store.dispatch("export", params);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
        this.hidden = false;
      }, 0);
    },
    getCurrentRow(row) {
      this.tagGroupId = row.groupId;
      console.log(this.tagGroupId)
    },
    save(row) {
      this.rows = row;
      axios({
        method: "post",
        url:
            this.$serverAdress +
            `/sys/common/download?filePath=${row.responseResultPath}`,
        responseType: "arraybuffer",
      }).then((res) => {
        this.download(res.data);
      });
    },
    download(data) {
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", this.rows.fileName);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url); //释放掉blob对象
    },
    handleCurrentChange(val) {
      this.rows = val;
      console.log("this.rows:",this.rows);
    },
  }
};
</script>
<style lang="scss">
.daogou-bder {
  .el-transfer-panel {
    width: 250px;
  }
}
</style>
<style lang="scss" scoped>
.daogou-bder {
  width: 700px;
  padding: 30px 10px;
  border: 1px solid #dddddd;
  text-align: center;
  .daogou-transfer {
    text-align: left;
    display: inline-block;
  }
}
.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.green{
  color: #2fc348;
}
</style>
